module.exports = __webpack_public_path__ + "static/media/A.c6bc8cfa.svg";